import { render } from "./hand-4.vue?vue&type=template&id=685921e6&scoped=true"
import script from "./hand-4.vue?vue&type=script&lang=js"
export * from "./hand-4.vue?vue&type=script&lang=js"

import "./hand-4.vue?vue&type=style&index=0&id=685921e6&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685921e6"]])

export default __exports__